import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import * as fromInfobooths from './+state/infobooths.reducer'
import { InfoboothsEffects } from './+state/infobooths.effects'
import { InfoboothsFacade } from './+state/infobooths.facade'

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromInfobooths.INFOBOOTHS_FEATURE_KEY, fromInfobooths.infoboothsReducer),
    EffectsModule.forFeature([InfoboothsEffects]),
  ],
  providers: [InfoboothsFacade],
})
export class GbDashboardSetupDataAccessInfoboothsModule {}
